module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C126"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C139"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/04_List_of#page_vii"
    }
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "C136"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowle#page_ix"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduc#page_1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1__In_Pu#page_14"
    }
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" In Pursuit of the Good Project")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Benef#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Beneficiaries as a Commodity")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__The_L#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" The Logframe and the History of the Market for Projects")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__The_H#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" The History of Humanitarian Authority and the Divisions of the Humanitarian Field")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__The_R#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" The Reform of Humanitarianism")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6__What#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" What about Human Rights?")])]), _vm._v(" "), _c('p', {
    staticClass: "C136"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Conclusi#page_168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appendix#page_177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix on Methods")])])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Bibliogr#page_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Index#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e1eaf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Contents.vue
// module id = 63
// module chunks = 0